export default __webpack_public_path__ + "static/media/images_overlay.23cf362e.png";